import React, { createContext, useContext, useState, useRef } from 'react';

const SpotifyContext = createContext();

export const useSpotify = () => {
  const context = useContext(SpotifyContext);
  if (!context) {
    throw new Error('useSpotify must be used within SpotifyProvider');
  }
  return context;
};

export const SpotifyProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [deviceId, setDeviceId] = useState(null);
  const [volume, setVolume] = useState(50);
  const [showPlayerBar, setShowPlayerBar] = useState(false);
  const [showNowPlaying, setShowNowPlaying] = useState(false);
  const [playerDismissed, setPlayerDismissed] = useState(false); // Track if player was manually closed
  const [progressMs, setProgressMs] = useState(0);
  const [durationMs, setDurationMs] = useState(0);
  const [currentContextUri, setCurrentContextUri] = useState(null); // Track current playlist/album context
  const [currentPlaylist, setCurrentPlaylist] = useState(null); // Track current playlist for manual navigation
  const [shuffleState, setShuffleState] = useState(false); // Spotify shuffle state
  const [repeatState, setRepeatState] = useState('off'); // Spotify repeat state: off, context, track
  const playerRef = useRef(null);

  const value = {
    isAuthenticated,
    setIsAuthenticated,
    accessToken,
    setAccessToken,
    currentTrack,
    setCurrentTrack,
    isPlaying,
    setIsPlaying,
    deviceId,
    setDeviceId,
    volume,
    setVolume,
    showPlayerBar,
    setShowPlayerBar,
    showNowPlaying,
    setShowNowPlaying,
    playerDismissed,
    setPlayerDismissed,
    progressMs,
    setProgressMs,
    durationMs,
    setDurationMs,
    currentContextUri,
    setCurrentContextUri,
    currentPlaylist,
    setCurrentPlaylist,
    shuffleState,
    setShuffleState,
    repeatState,
    setRepeatState,
    playerRef
  };

  return (
    <SpotifyContext.Provider value={value}>
      {children}
    </SpotifyContext.Provider>
  );
};
